import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Layout, Menu, Modal, Form } from 'antd';
import { Link, withRouter, useHistory } from 'react-router-dom';
import URI from 'global_config/uri';
import { ReactComponent as DeliveryReceiptIcon } from 'icons/delivery receipt.svg';
import { ReactComponent as InvoiceIcon } from 'icons/invoice.svg';
import { ReactComponent as PaymentIcon } from 'icons/payment.svg';
import { ReactComponent as SettingsIcon } from 'icons/settings.svg';
import { ReactComponent as UserIcon } from 'icons/user.svg';
import { ReactComponent as HomeIcon} from 'icons/home.svg';
import { ReactComponent as DRDeliveryIcon} from 'icons/drReport2.svg';

import { 
	SELECTED_SIDER_KEY, 
	LOGGEDIN_USER_DATA, 
	ACCESS_MATRIX,
	CUST_DE_FORM_CHANGED
} from 'global_config/constant-global';
import { UserAccessContext } from 'context/userAccess';

import Icon, {ExclamationCircleOutlined, FileTextOutlined} from '@ant-design/icons';
import './sider.css';
import { fetchMessageListAPI } from 'services/shared/fetchLovList';

const { Sider: AntSider } = Layout;

const SiderMenu = (props) =>{
	const { loggedIn, handleMenuClick } = props;
	const { userAccess } = useContext(UserAccessContext);
    const navigate = useHistory();
	const [messagesList, setMessagesList] = useState([]);

	console.log('🔍 SIDER userAccess:', userAccess);

	async function getLOVList(){
		try{
			const messages = await fetchMessageListAPI();
			setMessagesList(messages);
		}catch(error){
			console.log('sider error get message', error);
		}
	};

	useEffect(() => {
		getLOVList();
	}, []);

	const getUrl = (value) => {
		switch(value){
			case "home":
				return( navigate.push(URI.home.link) )
			case "users":
				return( navigate.push(URI.user.link) )
			case "settings":
				return( navigate.push(URI.settings.link) )
			case "invoice":
				return( navigate.push(URI.invoice.link) )
			case "delivery":
				return( navigate.push(URI.delivery.link) )
			case "payment":
				return( navigate.push(URI.payment.link) )
			case "acctReports":
				return( navigate.push(URI.acctReports.link) )
			case "drReports":
				return( navigate.push(URI.drReports.link) )
			default:
				return( navigate.push('/undefinedURL') )
		}
	};

	function callModdal(value){
        const m0008 = messagesList.filter((items) => items.message_code === 'M0008');
		Modal.confirm({
			title: m0008[0].message_title,
			icon: <ExclamationCircleOutlined />,
			content: m0008[0].message_display,
			okText: 'YES',
			cancelText: 'NO',
			onOk: ()=>{ getUrl(value) }
		});
	};

	function handleIconOnClick(e, param){
		const checkURL = window.location.pathname;

        if( checkURL.includes('add') || checkURL.includes('data_entry') ){
			callModdal(param);			

        }else if( checkURL.includes('update') ){
			if( checkURL.includes('invoice') || checkURL.includes('delivery') ){
				const recordData = window.history.state.state.record;
				if(recordData.status_name === 'CANCELLED' || recordData.status_name === 'POSTED'){
					//acd changes for invoice edit 
					if (recordData.status_name === 'POSTED'){
						callModdal(param);
					}else{
						getUrl(param)
					}
				}
				else{
					callModdal(param);
				}

			}else if( checkURL.includes('user') || checkURL.includes('agent') || checkURL.includes('payment')
			){
				const recordData = window.history.state.state;
				if(recordData.status === 'CANCELLED' || recordData.status === 'POSTED'){
					getUrl(param)
				}
				else{
					callModdal(param);
				}
			}else if(checkURL.includes('customer')){
				
				const initCustChangeModal = sessionStorage.getItem(CUST_DE_FORM_CHANGED) === 'true' ? true : false;
				if(initCustChangeModal){
					callModdal(param);
				}else{
					getUrl(param);
				}
			}
			else{
				getUrl(param)
			}

		}else {
            getUrl(param);
       	}
    };

	if(loggedIn && !window.location.pathname.includes('change_password')){
	// if(true){
	return(
		<div>
			<div className="logo" />
		<Menu
			className="side-menu" 
			mode="inline" 
			defaultSelectedKeys={[sessionStorage.getItem(SELECTED_SIDER_KEY) || '1']}
			onClick={handleMenuClick}
		>
			{
				(userAccess['home'].view === 'TRUE') ? (
					<Menu.Item key={URI.home.key} onClick={e => handleIconOnClick(e, 'home')}>
						<Icon style={{ fontSize: '180%'}} component={HomeIcon} />
						<span>Home</span>
				</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['users'].view === 'TRUE') ? (
				<Menu.Item key={URI.user.key} onClick={e => handleIconOnClick(e, 'users')}>
					<Icon style={{ fontSize: '180%'}} component={UserIcon} />
						<span>User</span>
				</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['settings'] && userAccess['settings'].view === 'TRUE') ? (
					<Menu.Item key={URI.settings.key} onClick={e => handleIconOnClick(e, 'settings')}>
						<Icon style={{ fontSize: '180%'}} component={SettingsIcon} />
						<span>Settings</span>
					</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['invoices'].view === 'TRUE') ? (
					<Menu.Item key={URI.invoice.key} onClick={e => handleIconOnClick(e, 'invoice')}>
						<Icon style={{ fontSize: '180%'}} component={InvoiceIcon} />
						<span>Invoice</span>
				</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['deliveryReceipt'].view === 'TRUE') ? (
					<Menu.Item key={URI.delivery.key} onClick={e => handleIconOnClick(e, 'delivery')} >
						<Icon style={{ fontSize: '180%'}} component={DeliveryReceiptIcon} key={'delivery'} />
						<span>Delivery Receipt</span>
					</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['payments'].view === 'TRUE') ? (
					<Menu.Item key={URI.payment.key} onClick={e => handleIconOnClick(e, 'payment')}>
						<Icon style={{ fontSize: '180%'}}component={PaymentIcon} />
						<span>Payment</span>
				</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['reports'].view === 'TRUE') ? (
					<Menu.Item key={URI.acctReports.key} onClick={e => handleIconOnClick(e, 'acctReports')}>
						<Icon style={{ fontSize: '180%'}}component={InvoiceIcon} />
						<span>Accounting Reports</span>
				</Menu.Item>
				) : (<></>)
			}
			{
				(userAccess['RPT_DR'] && userAccess['RPT_DR'].view === 'TRUE') ? (
					<Menu.Item key={URI.drReports.key} onClick={e => handleIconOnClick(e, 'drReports')}>
						<Icon style={{ fontSize: '180%'}} component={DRDeliveryIcon} />
						<span>DR Reports</span>
				</Menu.Item>
				) : (<></>)
			}
		</Menu>
		</div>
	);
	}else{
		return(<></>);
	}
}

function Sider({ collapsed }) {
	const loggedIn = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA, ));	

	function handleMenuClick({ key })  {
		const selectedKey = key.includes('inventory') ? 9 : key;	
		sessionStorage.setItem(SELECTED_SIDER_KEY, selectedKey);
		// workaround to avoid delays in stepsPage
		// if(key === '2')
		// 	sessionStorage.setItem(LR_REQUEST_TYPE, 'create');
		// if(key === '3')
		// 	sessionStorage.setItem(LR_REQUEST_TYPE, 'edit');
	}

	return (
		<AntSider
			trigger={null}
			collapsible
			collapsed={collapsed}
		>
			<SiderMenu 
			loggedIn={loggedIn} 
			handleMenuClick={handleMenuClick}/>
		</AntSider>
	);
}

Sider.propTypes = {
	collapsed: PropTypes.bool
};

Sider.defaultProps = {
	collapsed: null
}

// @ts-ignore
export default withRouter(Sider);